import Vue from 'vue'
import VueRouter from 'vue-router'
import env from '@/env'
import {routes} from './routes'
import store from '../store'
Vue.use(VueRouter)

export const createRouter = () => {
    const router = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        linkActiveClass: 'active',
        linkExactActiveClass: 'active',
        routes,
    })

    router.beforeEach(async (to, from, next) => {
        if (to.matched.some(record => record.meta.auth)) {
            // Se não está logado, verifica se tem token no localStorage
            try {
                await store.dispatch('auth/refreshUser');
            } catch (error) {
                // Se falhar, remove o token e redireciona para login
                localStorage.removeItem('token');
                return next({ name: 'login' });
            }

            
            if (!store.getters['auth/isLoggedIn']) {
                const token = localStorage.getItem('token');
                if (token) {
                    // Tenta recarregar o usuário com o token
                    
                } else {
                    return next({ name: 'login' });
                }
            }
            
            // Verifica se o usuário foi carregado com sucesso
            if (!store.getters['auth/isLoggedIn']) {
                return next({ name: 'login' });
            }
            
            const currentUser = store.state.auth.user;
            if (!currentUser.plan_id && env.checkout && to.name !== 'subscription') {                    
                return next({ name: 'subscription' });
            }
            document.title = to.meta.title + ' | ' + env.title;
            store.commit('api/resetValues', {});
            return next();
        }
        document.title = to.meta.title + ' | ' + env.title;
        next();
    });

    return router
}

const router = createRouter()
export default router
